import { createFileRoute } from "@tanstack/react-router"

import { adminDeletionsSearchSchema } from "@/features/admin/admin-search-schema"
import { AdminDeletionsPage } from "@/pages/admin/deletions"

export const Route = createFileRoute("/_authenticated/admin/deletions")({
  validateSearch: (search) => adminDeletionsSearchSchema.parse(search),
  component: AdminDeletionsPage,
})
